(function(){
    'use strict';

    if($('.smp-grid-gallery-item a').length){
        $('.smp-grid-gallery-item a').on('click',function(){
            var modal = $(this).attr('href'),
                img = $(this).html(),
                width = $(this).find('img').width();
                
            if (width < 1106) {
                width = width + 32;
                $(modal).find('.modal-dialog').css('max-width', width + 'px');
            } else {
                $(modal).find('.modal-dialog').css('max-width','');
            }
            $(modal).find('.modal-body').html(img);
        });
    }
}());